<div class="flex flex-col gap-4">
  <!-- Row 1: Data configuration -->
  <div class="flex flex-wrap items-end gap-4">
    <!-- Forecast Version Multiselect -->
    <pm-form-field label="REPORTING.TOOLBAR.VERSIONS">
      <pm-form-input-select
        [data]="versionOptions()"
        [multiSelect]="true"
        [ngModel]="reportingState.selectedVersionIds()"
        (ngModelChange)="onVersionSelectionChange($event)"
      />
    </pm-form-field>

    <!-- Additional Time Series Multiselect -->
    @if (additionalTimeSeriesNames().length > 0) {
      <pm-form-field label="REPORTING.TOOLBAR.ADDITIONAL_TIME_SERIES">
        <pm-form-input-select
          [data]="timeSeriesOptions()"
          [multiSelect]="true"
          [allowUnselect]="true"
          [ngModel]="reportingState.selectedTimeSeries()"
          (ngModelChange)="onTimeSeriesSelectionChange($event)"
        />
      </pm-form-field>
    }

    <!-- Spacer -->
    <div class="flex-1"></div>

    <!-- Admin Import Icon Button -->
    @if (isAdmin()) {
      <pm-button
        variant="outlined"
        [icon]="importIcon"
        [isLoading]="reportingState.isImportInProgress()"
        [disabled]="reportingState.isImportInProgress()"
        [title]="
          reportingState.isImportInProgress()
            ? ('REPORTING.IMPORT_DIALOG.IMPORT_IN_PROGRESS' | translate)
            : ('REPORTING.IMPORT_DIALOG.TITLE' | translate)
        "
        (handleClick)="openImportDialog()"
      />
    }
  </div>

  <hr />

  <!-- Row 2: Date range -->
  <div class="flex flex-wrap items-end gap-4 justify-end">
    <pm-form-field label="REPORTING.TOOLBAR.DATE_RANGE">
      <pm-form-input-daterange [formControl]="dateRange" />
    </pm-form-field>
  </div>
</div>
